// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__vaRAP","header":"ClearentDisclaimer_header__37ir2","inner":"ClearentDisclaimer_inner__25rea"};